import React, { useState, useRef } from 'react';
import './BookConsultation.css';

const BookConsultation = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    preference: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Submit to Netlify Forms using AJAX
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "consultation", ...formData })
      });

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error processing form:', error);
      alert('There was an error processing your request. Please email us directly at lisa@canadianumbrella.ca');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="consultation">
        <div className="container">
          <div className="success-message">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
            </div>
            <h2>Thank You!</h2>
            <p>Your consultation request has been submitted successfully. We'll contact you within 24 hours to schedule your consultation.</p>
            <button onClick={() => setIsSubmitted(false)} className="btn btn-primary">
              Submit Another Request
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="consultation">
      {/* Hero Section */}
      <section className="consultation-hero">
        <div className="container">
          <h1 className="consultation-title">Book Your Consultation</h1>
          <p className="consultation-subtitle">Schedule a consultation with Lisa Halliwell, RCIC at Canadian Umbrella Immigration Services, Charlottetown, PE</p>
        </div>
      </section>


      {/* Main Content */}
      <section className="consultation-content">
        <div className="container">
          <div className="content-grid">
            {/* Form Section */}
            <div className="form-section">
              <h2>Request Consultation</h2>
              
              {/* Consultation Details */}
              <div className="consultation-details">
                <p>The more details you can share when booking your consultation, the better we can prepare to make the most of our time together.</p>
                <p>Once your consultation is booked, we'll send you a Consultation Agreement to review and sign, along with simple instructions for paying the consultation fee.</p>
                <p>You can choose to have your consultation in person, by telephone, or via Microsoft Teams Meeting — whichever works best for you</p>
                <p className="consultation-cta-text">Ready to chat? Click the button below to book your consultation and let's get started!</p>
              </div>
              
              <form ref={form} onSubmit={handleSubmit} className="consultation-form" name="consultation" method="POST">
                <input type="hidden" name="form-name" value="consultation" />
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="service">Service of Interest</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">Select a service</option>
                    <option value="express-entry">Express Entry</option>
                    <option value="family-sponsorship">Family Sponsorship</option>
                    <option value="study-permit">Study Permit</option>
                    <option value="work-permit">Work Permit</option>
                    <option value="provincial-nominee">Provincial Nominee Program</option>
                    <option value="business-immigration">Business Immigration</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="preference">Consultation Preference</label>
                  <select
                    id="preference"
                    name="preference"
                    value={formData.preference}
                    onChange={handleChange}
                  >
                    <option value="">Select preference</option>
                    <option value="in-person">In Person</option>
                    <option value="phone">Phone</option>
                    <option value="microsoft-teams">Microsoft Teams Meeting</option>
                    <option value="email">Email</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    placeholder="Tell us about your immigration goals and any specific questions you have..."
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-large" disabled={isLoading}>
                  {isLoading ? 'Sending...' : 'Book Consultation'}
                </button>
                
                <div className="form-contact-info">
                  <p>Or email us directly at <a href="mailto:lisa@canadianumbrella.ca">lisa@canadianumbrella.ca</a></p>
                </div>
              </form>
            </div>

            {/* Info Section */}
            <div className="info-section">
              <h2>Consultations</h2>
              <div className="consultation-info">
                <p className="consultation-intro">We offer flexible consultation options to suit your needs:</p>
                
                <div className="consultation-options">
                  <div className="consultation-option">
                    <div className="consultation-duration">Email Inquiry</div>
                    <div className="consultation-price">$50</div>
                    <div className="consultation-description">Sometimes all you need is a quick answer, clarification or confirmation. If you have a straightforward immigration question — this option is ideal for you. For a $50 flat fee, you can email your question and receive a clear, reliable answer from a Registered Canadian Immigration Consultant.</div>
                  </div>
                  
                  <div className="consultation-option">
                    <div className="consultation-duration">30 minutes</div>
                    <div className="consultation-price">$125</div>
                    <div className="consultation-description">Perfect for quick questions or general guidance.</div>
                  </div>
                  
                  <div className="consultation-option">
                    <div className="consultation-duration">60 minutes</div>
                    <div className="consultation-price">$250</div>
                    <div className="consultation-description">Ideal for an in-depth, comprehensive discussion.</div>
                  </div>
                </div>
                
              </div>

              {/* Contact Info */}
              <div className="contact-info-section">
                <h3>Contact Information</h3>
                <div className="contact-items">
                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                      </svg>
                    </div>
                    <div>
                      <h4>Address</h4>
                      <p>Suite 240, 119 Kent Street<br />Charlottetown, PE C1A 1N3</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                      </svg>
                    </div>
                    <div>
                      <h4>Phone</h4>
                      <p>902-566-3622</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <div className="contact-icon">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                      </svg>
                    </div>
                    <div>
                      <h4>Email</h4>
                      <p>lisa@canadianumbrella.ca</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookConsultation; 